// 法务-投诉处理
import request from '@/router/axios';

// 投诉处理列表
export const getComplaintHandlingList = (current, size, data) => {
  return request({
    url: '/api//v2/blade-loanPost/loan/complaintHandling-page',
    method: 'post',
    data: {
      ...data,
      current,
      size,
    },
  });
};